import {NgModule} from '@angular/core';
import {InvestmentSectionComponent} from './investment-sections.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CoreTeamSectionModule} from '../../../../common/core-team-section/core-team-section.module';
import {WeHaveBeenInTheNewsModule} from '../../../../common/we-have-been-in-the-news/we-have-been-in-the-news.module';
import {AwardsAndAccreditationsModule} from '../../../../common/awards-and-accreditations/awards-and-accreditations.module';
import {MatButtonModule} from '@angular/material';
import { ContactUsModule } from '../../../../views/contact-us/contact-us.module';
import { RbiDisclaimerModule } from '../../../../common/rbi-disclaimer/rbi-disclaimer.module';

@NgModule({
    declarations: [InvestmentSectionComponent],
    imports: [CommonModule, RouterModule, CoreTeamSectionModule, WeHaveBeenInTheNewsModule, AwardsAndAccreditationsModule, MatButtonModule, ContactUsModule, RbiDisclaimerModule],
    exports: [InvestmentSectionComponent]
})
export class InvestmentSectionsModule {
}
